import { FeatureFlags } from '~constants/featureFlags';
import { useFeatureFlag } from '~utils/hooks/useFeatureFlag';

import {
  CompanySettingCatalogEntry,
  CompanySettingGatingFeatureFlag,
  companySettingKeys,
  companySettingsCatalog,
} from './companySettingsCatalog';

export default function useVisibleCompanySettingKeys() {
  const chargeBasedSettlements = useFeatureFlag({
    featureFlagKey: FeatureFlags.chargeBasedSettlements,
  });
  const driverAgent = useFeatureFlag({ featureFlagKey: FeatureFlags.driverAgent });
  const liveEtaEnabled = useFeatureFlag({ featureFlagKey: FeatureFlags.liveEtaEnabled });
  const payCommissions = useFeatureFlag({ featureFlagKey: FeatureFlags.payCommissions });

  const gateFlags: Partial<Record<FeatureFlags, boolean>> = {
    [FeatureFlags.chargeBasedSettlements]: chargeBasedSettlements,
    [FeatureFlags.driverAgent]: driverAgent,
    [FeatureFlags.liveEtaEnabled]: liveEtaEnabled,
    [FeatureFlags.payCommissions]: payCommissions,
  } satisfies Record<CompanySettingGatingFeatureFlag, boolean>;

  return companySettingKeys.filter((key) => {
    const { featureFlag }: CompanySettingCatalogEntry = companySettingsCatalog[key];

    return featureFlag ? Boolean(gateFlags[featureFlag]) : true;
  });
}
